import React, { Component } from "react";
import moment from "moment";
import { withStyles } from "material-ui/styles";
import Grid from "material-ui/Grid";
import Card, { CardContent, CardMedia } from "material-ui/Card";
import Typography from "material-ui/Typography";
import Table, {
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from "material-ui/Table";

const styles = (theme) => ({
  card: {
    display: "flex",
  },
  details: {
    display: "flex",
    flexDirection: "column",
    width: "100%",
  },
  content: {
    flex: "1 0 auto",
  },
  cover: {
    width: 151,
    height: 151,
  },
});

class App extends Component {
  constructor() {
    super();

    this.state = {
      dayIndex: moment().isoWeekday(),
    };
  }

  computeCurrentDayClass(index) {
    if (index === this.state.dayIndex) {
      return "current-day";
    }

    return null;
  }

  render() {
    const { classes } = this.props;

    return (
      <Grid item xs={12} md={4}>
        <Card className={classes.card}>
          <div className={classes.details}>
            <CardContent className={classes.content}>
              <Typography variant="title" gutterBottom>
                Horaires d'ouverture
              </Typography>
            </CardContent>
            <CardMedia>
              <Table className={"tableau-horaires"}>
                <TableBody>
                  <TableRow className={this.computeCurrentDayClass(1)}>
                    <TableCell>Lundi</TableCell>
                    <TableCell numeric>11:30–14:30</TableCell>
                    <TableCell numeric>18:00–22:30</TableCell>
                  </TableRow>
                  <TableRow className={this.computeCurrentDayClass(2)}>
                    <TableCell>Mardi</TableCell>
                    <TableCell numeric>11:30–14:30</TableCell>
                    <TableCell numeric>18:00–22:30</TableCell>
                  </TableRow>
                  <TableRow className={this.computeCurrentDayClass(3)}>
                    <TableCell>Mercredi</TableCell>
                    <TableCell numeric>11:30–14:30</TableCell>
                    <TableCell numeric>18:00–22:30</TableCell>
                  </TableRow>
                  <TableRow className={this.computeCurrentDayClass(4)}>
                    <TableCell>Jeudi</TableCell>
                    <TableCell numeric>11:30–14:30</TableCell>
                    <TableCell numeric>18:00–22:30</TableCell>
                  </TableRow>
                  <TableRow className={this.computeCurrentDayClass(5)}>
                    <TableCell>Vendredi</TableCell>
                    <TableCell numeric>11:30–14:30</TableCell>
                    <TableCell numeric>18:00–22:30</TableCell>
                  </TableRow>
                  <TableRow className={this.computeCurrentDayClass(6)}>
                    <TableCell>Samedi</TableCell>
                    <TableCell numeric>11:30–14:30</TableCell>
                    <TableCell numeric>18:00–22:30</TableCell>
                  </TableRow>
                  <TableRow className={this.computeCurrentDayClass(7)}>
                    <TableCell>Dimanche</TableCell>
                    <TableCell numeric>Fermé</TableCell>
                    <TableCell numeric></TableCell>
                  </TableRow>
                </TableBody>
              </Table>
            </CardMedia>
          </div>
        </Card>
      </Grid>
    );
  }
}

export default withStyles(styles)(App);



// WEBPACK FOOTER //
// ./src/components/Horaires/Horaires.js